export { useOrderTypeTakeoverPrompt } from './use-order-type-takeover-prompt';
// `useIsOrderTypeTakeoverEnabled` is the single public gate: it combines the
// admin store setting with the rollout flag. The setting-only helper
// (`isOrderTypeTakeoverEnabled`) is intentionally NOT re-exported here so
// callers can't accidentally bypass the flag guard.
export { useIsOrderTypeTakeoverEnabled, ORDER_TYPE_TAKEOVER_FLAG } from './use-is-order-type-takeover-enabled';
